import React, { useEffect, useState } from 'react';
import { getForms } from '../../../actions/formActions';
import { validateCompany } from '../../../actions/stocksActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from '../../Common/SearchBox/SearchBox';
import Listing from '../../Common/Listing/Listing';
import _ from 'lodash'

const CompanyValidate = (props) => {
    const dispatch = useDispatch();
    const searchFormKey = "company_validate_search_form";
    const formListKeyResponseMapping = {
        "company_validate_list_nseCode": "noCode",
        "company_validate_list_historyLength": "historyLength",
        "company_validate_list_historyDate": "historyDate",
        "company_validate_list_historyData": "historyDataUnAvailable",
        "company_validate_duplicate_entry": "duplicateList",
        "company_validate_list_matchLiveData": "historyList",
        "company_validate_list_upstox_history": "upstox",
        "company_validate_list_upstox_instrument": "upstoxInsKey",
    };
    const formState = useSelector((state) => state.forms);
    const stocksState = useSelector((state) => state.stocks);
    const { validateResponse = {}, } = stocksState;
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchFormKey] || {};
    const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));
    const [fetchingList, setFetchingList] = useState(false);

    useEffect(() => {
        dispatch(getForms(searchFormKey));
        Object.keys(formListKeyResponseMapping).map(formKey => {
            dispatch(getForms(formKey));
        });
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchBoxJson)) {
            setFetchingSearchForm(false);
        }
    }, [searchBoxJson]);

    const handleSearch = (payload) => {
        const { metaInfo = {}, ...restData } = payload;
        const finalPayload = { ...metaInfo, ...restData };
        setFetchingList(true);
        dispatch(validateCompany(finalPayload, formListKeyResponseMapping));
    }

    useEffect(() => {
        if (!_.isEmpty(validateResponse) && fetchingList) {
            setFetchingList(false);
        }
    }, [validateResponse])

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBox
                searchBoxJson={searchBoxJson}
                onSearch={handleSearch}
                fetchingForm={fetchingSearchForm}
                fetchingList={fetchingList}
            />
            {fetchingList ? '' : Object.keys(formListKeyResponseMapping).map(key => {
                const listingData = validateResponse[formListKeyResponseMapping[key]];
                if (_.isEmpty(listingData))
                    return '';
                const { headers = [], data = [], meta = {} } = listingData;
                return <>
                    <Listing
                        headers={headers}
                        data={data}
                        meta={meta}
                    />
                </>
            })}
        </div>
    );
}

export default CompanyValidate;
